import { useEffect } from "react";

import { useSocketAuthenticated } from "../../SocketContext";
import api from "../../../../services/api";

const SocketContactsViewList = ({ dispatch, filter, selectedConnectionIds }) => {
  //  ***************
  //  ** Variables **
  //  ***************
  const { getSocket } = useSocketAuthenticated();

  //  *****************
  //  ** Use Effects **
  //  *****************
  useEffect(() => {
    const socket = getSocket();

    if (socket) {
      const handleContactView = async (data) => {
        const isCurrentTenantTarget = `${api.defaults.headers.tenantId}` === `${data.tenantId}`;
        if (!isCurrentTenantTarget) return;

        const { contactId, whatsappId } = data;
        if (!contactId && !whatsappId) return;

        const shouldSkipDispatch = selectedConnectionIds.length > 0 && !selectedConnectionIds.includes(whatsappId);
        if (data.action === "updateUnreadTicket") {
          if (shouldSkipDispatch) return;
          dispatch({ type: "RESET_UNREAD", payload: { contactId, whatsappId } });
        }

        if (["createAppMessage", "updateTicket"].includes(data.action)) {
          if (shouldSkipDispatch) return;

          const { data: { contactView } } = await api.get(`/contactsView/${contactId}`, { params: { whatsappId, filter } });
          dispatch({ type: "UPDATE_CONTACT_VIEW", payload: { contactView, contactId, whatsappId } });
        }
      };

      socket.on("ticket", handleContactView);
      socket.on("appMessage", handleContactView);

      return () => {
        socket.off("ticket", handleContactView);
        socket.off("appMessage", handleContactView);
      };
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, filter, selectedConnectionIds]);



  //  ************
  //  ** Return **
  //  ************
  return (<></>);
};

export default SocketContactsViewList;
